"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZORA_IPFS_GATEWAY = exports.ZORA_USERNAME_API_URL = exports.OPENSEA_API_URL_BY_NETWORK = exports.THEGRAPH_UNISWAP_URL_BY_NETWORK = exports.ZORA_INDEXER_URL_BY_NETWORK = exports.RPC_URL_BY_NETWORK = exports.ENS_GRAPH_URL_BY_NETWORK = exports.THEGRAPH_API_URL_BY_NETWORK = void 0;
const networks_1 = require("./networks");
exports.THEGRAPH_API_URL_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: 'https://api.thegraph.com/subgraphs/name/ourzora/zora-v1',
    [networks_1.Networks.RINKEBY]: 'https://api.thegraph.com/subgraphs/name/ourzora/zora-v1-rinkeby',
    [networks_1.Networks.POLYGON]: 'https://api.thegraph.com/subgraphs/name/ourzora/zora-v1-polygon',
    [networks_1.Networks.MUMBAI]: 'https://api.thegraph.com/subgraphs/name/ourzora/zora-v1-mumbai',
};
exports.ENS_GRAPH_URL_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: 'https://api.thegraph.com/subgraphs/name/ensdomains/ens',
    [networks_1.Networks.RINKEBY]: 'https://api.thegraph.com/subgraphs/name/ensdomains/ensrinkeby',
};
exports.RPC_URL_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: 'https://cloudflare-eth.com',
    [networks_1.Networks.RINKEBY]: 'https://rinkeby-light.eth.linkpool.io',
};
exports.ZORA_INDEXER_URL_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: 'https://indexer-prod-mainnet.zora.co/v1/graphql',
    [networks_1.Networks.RINKEBY]: 'https://indexer-dev-rinkeby.zora.co/v1/graphql',
};
exports.THEGRAPH_UNISWAP_URL_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2',
    [networks_1.Networks.RINKEBY]: 'https://api.thegraph.com/subgraphs/name/ianlapham/uniswap-v2-rinkeby',
};
exports.OPENSEA_API_URL_BY_NETWORK = {
    [networks_1.Networks.MAINNET]: 'https://api.opensea.io/api/v1/',
    [networks_1.Networks.RINKEBY]: 'https://rinkeby-api.opensea.io/api/v1/',
};
exports.ZORA_USERNAME_API_URL = 'https://zora.co/api/users';
exports.ZORA_IPFS_GATEWAY = 'https://zora-prod.mypinata.cloud/ipfs/';
